import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { API_BASE } from "@/config/api"
import { HrSubnav } from "./HrSubnav"
import { toast } from "sonner"

const API = API_BASE

export default function HrApp() {
  const { t } = useTranslation()
  const [list, setList] = useState([])
  const [employees, setEmployees] = useState([])
  const [form, setForm] = useState({
    employee_id: "",
    beneficiary_name: "",
    dgaspc_name: "",
    decision_number: "",
    hourly_rate: 0,
    planned_hours_monthly: 0,
  })
  const [reportMonth, setReportMonth] = useState(() => new Date().toISOString().slice(0, 7))

  const load = () => {
    axios.get(`${API}/hr/app/assignments`).then((r) => setList(r.data)).catch(() => {})
    axios
      .get(`${API}/hr/employees`, { params: { status: "active" } })
      .then((r) => setEmployees(r.data.filter((e) => e.role_code === "app")))
      .catch(() => {})
  }

  useEffect(() => {
    load()
  }, [])

  const submit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${API}/hr/app/assignments`, form)
      toast.success(t("app.hr.appModule.toastAssignment"))
      load()
    } catch {
      toast.error(t("app.hr.appModule.toastError"))
    }
  }

  const downloadReport = async (id) => {
    const { data } = await axios.get(`${API}/hr/app/assignments/${id}/report`, { params: { month: reportMonth } })
    if (data.pdf_base64) {
      const a = document.createElement("a")
      a.href = `data:application/pdf;base64,${data.pdf_base64}`
      a.download = `raport-app-${reportMonth}.pdf`
      a.click()
    }
    toast.success(`Total indemnizație: ${data.report?.indemnity_total} RON`)
  }

  const saveHours = async (id, hours) => {
    await axios.patch(`${API}/hr/app/assignments/${id}/hours`, null, { params: { month: reportMonth, hours } })
    toast.success(t("app.hr.appModule.toastHoursSaved"))
    load()
  }

  return (
    <AppLayout title={t("app.hr.appModule.title")}>
      <HrSubnav />
      <p className="text-sm text-muted-foreground mb-4">Legea 448/2006 — raportare ore către DGASPC / primărie.</p>
      <form onSubmit={submit} className="rounded-xl border border-border p-4 mb-6 grid sm:grid-cols-2 gap-3 max-w-2xl">
        <div>
          <Label>Asistent APP</Label>
          <select
            className="w-full h-10 border rounded-md px-2 text-sm"
            required
            value={form.employee_id}
            onChange={(e) => setForm({ ...form, employee_id: e.target.value })}
          >
            <option value="">—</option>
            {employees.map((e) => (
              <option key={e.id} value={e.id}>
                {e.first_name} {e.last_name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <Label>Beneficiar</Label>
          <Input required value={form.beneficiary_name} onChange={(e) => setForm({ ...form, beneficiary_name: e.target.value })} />
        </div>
        <div>
          <Label>DGASPC</Label>
          <Input value={form.dgaspc_name} onChange={(e) => setForm({ ...form, dgaspc_name: e.target.value })} />
        </div>
        <div>
          <Label>Nr. decizie</Label>
          <Input value={form.decision_number} onChange={(e) => setForm({ ...form, decision_number: e.target.value })} />
        </div>
        <div>
          <Label>Tarif orar RON</Label>
          <Input type="number" value={form.hourly_rate} onChange={(e) => setForm({ ...form, hourly_rate: +e.target.value })} />
        </div>
        <div>
          <Label>Ore planificate / lună</Label>
          <Input type="number" value={form.planned_hours_monthly} onChange={(e) => setForm({ ...form, planned_hours_monthly: +e.target.value })} />
        </div>
        <Button type="submit" className="sm:col-span-2">
          Salvează
        </Button>
      </form>
      <div className="mb-3">
        <Label>Lună raport</Label>
        <Input type="month" className="max-w-xs" value={reportMonth} onChange={(e) => setReportMonth(e.target.value)} />
      </div>
      <ul className="space-y-4">
        {list.map((a) => (
          <li key={a.id} className="rounded-xl border border-border p-4">
            <p className="font-medium">{a.beneficiary_name}</p>
            <p className="text-sm text-muted-foreground">
              {a.dgaspc_name} · decizie {a.decision_number}
            </p>
            <div className="flex gap-2 mt-3 items-end">
              <Input type="number" placeholder="Ore lucrate" className="max-w-[120px]" onBlur={(e) => saveHours(a.id, +e.target.value)} />
              <Button size="sm" variant="outline" onClick={() => downloadReport(a.id)}>
                Raport PDF
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </AppLayout>
  )
}
